export default __webpack_public_path__ + "static/media/spotify.8d14c921.png";